import React, { ReactNode, useRef, useEffect } from 'react';

export enum RadioGroupVariant {
    STANDARD = 'standard',
    TITLE = 'title'
}

interface IRadioGroupProps {
    // attribute
    column?: boolean;
    isDark?: boolean;
    describedBy?: string;
    isError?: boolean;
    shouldHideRequiredLabelling?: boolean;
    identifier?: string;
    xsItemsPerRow?: 1 | 2;
    lgItemsPerRow?: number;
    mdItemsPerRow?: number;
    name: string;
    quietValidate?: boolean;
    isRequired?: boolean;
    smItemsPerRow?: number;
    value: string;
    variant?: RadioGroupVariant;
    xlItemsPerRow?: string;
    // events
    onChange: (value: string) => void;
    // slots
    children: ReactNode;
    description?: string;
    errorMessage?: string;
    legend?: string;
    legendToolTip?: string;
    // extra nous
    dataTestId?: string;
}

export const RadioGroup: React.FC<IRadioGroupProps> = ({
    // attribute
    column,
    isDark,
    describedBy,
    isError,
    shouldHideRequiredLabelling,
    identifier,
    xsItemsPerRow,
    lgItemsPerRow,
    mdItemsPerRow,
    name,
    quietValidate,
    isRequired,
    smItemsPerRow,
    value,
    variant,
    xlItemsPerRow,
    // events
    onChange,
    // slots
    children,
    description,
    errorMessage,
    legend,
    legendToolTip,
    // extra nous
    dataTestId
}) => {
    const ref = useRef(null);

    // evenement seulement triggered quand le radio est checked
    const handleRadioChange = (newValue: string) => {
        onChange(newValue);
    };

    useEffect(() => {
        ref.current.addEventListener('dsdRadioGroupChange', (e) => {
            if (onChange) handleRadioChange(e?.detail?.value);
        });
    }, []);

    return (
        // @ts-ignore
        <dsd-radio-group
            ref={ref}
            data-testid={dataTestId}
            column={column}
            dark={isDark}
            described-by={describedBy}
            error={isError}
            hide-required-labelling={shouldHideRequiredLabelling}
            identifier={identifier}
            items-per-row={xsItemsPerRow}
            lg-items-per-row={lgItemsPerRow}
            md-items-per-row={mdItemsPerRow}
            name={name}
            quiet-validate={quietValidate}
            required={isRequired}
            sm-items-per-row={smItemsPerRow}
            value={value}
            variant={variant}
            xl-items-per-row={xlItemsPerRow}
        >
            <span slot="description">{description}</span>
            <span slot="error">{errorMessage}</span>
            <span slot="legend">{legend}</span>
            <span slot="legend-tooltip">{legendToolTip}</span>
            {children}
            {/* @ts-ignore */}
        </dsd-radio-group>
    );
};
